import React, { useState } from "react";
import "./styles/slider.sass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
const images = require.context("./sliderImg", true);
const imageList = images.keys().map((image) => images(image));
const Slider = ({ slider }) => {
  const [sliderValue, setSliderValue] = useState(50);
  const [numberPhoto, setNumberPhoto] = useState(0);
  const [animate, setAnimate] = useState([false, ""]);
  const handleChange = (e) => {
    setSliderValue(e.target.value);
  };
  const startAnimation = (side) => {
    setAnimate([true, side]);
    setTimeout(() => setAnimate([false, side]), 1000);
  };
  const styleAnimation = animate[0]
    ? {
        animation: `${
          animate[1] == "next"
            ? "nextPhotoAnimation 1s"
            : "prevPhotoAnimation 1s"
        }`,
      }
    : {};
  return (
    <div className='slider_box '>
      <div className={`slider`}>
        <img
          src={imageList[numberPhoto]}
          alt='before'
          className='before'
          style={styleAnimation}
        />

        {slider !== false && (
          <>
            <img
              src={imageList[numberPhoto + 1]}
              alt='after'
              className='after'
              style={{
                clipPath: `inset(0 ${100 - sliderValue}% 0 0)`,
                ...styleAnimation,
              }}
            />
            <div className='middle_line' style={{ left: `${sliderValue}%` }}>
              <div>
                <FontAwesomeIcon icon={faArrowRight} flip='horizontal' />
                <FontAwesomeIcon icon={faArrowRight} />
              </div>
            </div>
            <input
              type='range'
              min='0'
              max='100'
              value={sliderValue}
              onChange={handleChange}
              aria-label='Slider'
            />
          </>
        )}
      </div>
      <div className='button_box'>
        <button
          aria-label='Poprzednie'
          onClick={(e) => {
            setNumberPhoto((prev) => (prev > 0 ? prev - 1 : prev));
            startAnimation("prev");
          }}
        >
          <FontAwesomeIcon icon={faArrowRight} flip='horizontal' />
        </button>
        <button
          aria-label='Następne'
          onClick={(e) => {
            setNumberPhoto((prev) => (prev < images.length ? prev + 1 : prev));
            startAnimation("next");
          }}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
    </div>
  );
};

export default Slider;
